import styled from "styled-components";
import { TypeColorNames } from "../../../theme/colors";

export const Container = styled.div<{background?: TypeColorNames}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${props => props.background ? 
    props.theme.colors[props.background] : 
    props.theme.colors.inputBackground
  };
  padding: 32px;
  gap: 16px;
  justify-content: start;
  align-items: space-between;
  border-radius: 8px;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    padding: 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
